import * as React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@material-ui/core";
import BasicFieldsSection from "./BasicFieldsSection";
import HealthProfileFieldsSection from "./HealthProfileFieldsSection";
import { API } from "aws-amplify";
import { LoadingSpinner } from "../../../../utils/LoadingSpinner";
import { getCatalogAddresses } from "../../../../../services/addressService";

interface IProps {
  data?: any;
  forCheckout?: any;
  forOrder?: any;
  healthProfile?: any;
  isDemographicProfile?: boolean; 
}

interface IState {
  addresses: any[];
  customerJourneyType: any;
  dateOfBirth: any;
  gender: any;
  identityValidationStatus: string;
  identityValidationStatusKatara: boolean;
  legalFirstName: any;
  legalLastName: any;
  medications: any[];
  middleName: any;
  passcode: any;
  residentialAddressId: any;
  setDefaultAddress: boolean;
  setDefaultPaymentMethod: boolean;
  ssn: string;
  suffix: any;
}

class DemographicProfileFieldsSection extends React.Component<IProps, IState> {
  private basicFieldsSection: any;
  private healthProfileFieldsSection: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      addresses: [],
      customerJourneyType: "sign-up-for-self",
      dateOfBirth: "",
      gender: ["Male", "Female"][Math.floor(Math.random() * 2)],
      identityValidationStatus: "VALIDATION_SUCCESS",
      identityValidationStatusKatara: true,
      legalFirstName: "",
      legalLastName: "",
      medications: [],
      middleName: "",
      passcode: "1111",
      residentialAddressId: "",
      setDefaultAddress: false,
      setDefaultPaymentMethod: false,
      ssn: "",
      suffix: "",
    };

    this.getAddresses = this.getAddresses.bind(this);
    this.getMedications = this.getMedications.bind(this);
    this.getDrugs = this.getDrugs.bind(this);
    this.handleLegalFirstName = this.handleLegalFirstName.bind(this);
    this.handleMiddleName = this.handleMiddleName.bind(this);
    this.handleLegalLastName = this.handleLegalLastName.bind(this);
    this.handleSuffix = this.handleSuffix.bind(this);
    this.handleIdentityValidationStatus =
      this.handleIdentityValidationStatus.bind(this);
    this.handleResidentialAddressId =
      this.handleResidentialAddressId.bind(this);
    this.handleDateOfBirth = this.handleDateOfBirth.bind(this);
    this.handleGender = this.handleGender.bind(this);
    this.handleSsn = this.handleSsn.bind(this);
    this.handleIdentityValidationStatusKatara =
      this.handleIdentityValidationStatusKatara.bind(this);
    this.handleSetDefaultAddress = this.handleSetDefaultAddress.bind(this);
    this.handleSetDefaultPayment = this.handleSetDefaultPayment.bind(this);
  }

  public render() {
    const showLoadingSpinner = this.state.addresses.length === 0;
    if (!showLoadingSpinner && this.state.residentialAddressId === "") {
      for (const address of this.state.addresses) {
        if (address.defaultOption) {
          this.setState({ residentialAddressId: address.addressId });
          break;
        }
      }
    }

    return (
      <Grid item xs={12}>
        {showLoadingSpinner && <LoadingSpinner />}

        <BasicFieldsSection 
          ref={(ref) => (this.basicFieldsSection = ref)}
          isDemographicProfile={this.props.isDemographicProfile}
        />

        <Grid item xs={12}>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            spacing={3}
          >
            <Grid item xs>
              <InputLabel
                style={{
                  color: "red",
                  fontSize: 18,
                  fontWeight: "bold",
                }}
              >
                Demographic Profile
              </InputLabel>
            </Grid>

            <Grid item xs>
              <FormControl>
                <InputLabel>Customer Journey</InputLabel>
                <Select
                  value={this.state.customerJourneyType}
                  style={{ width: 225 }}
                >
                  <MenuItem value="sign-up-for-self">
                    <em>SignUpForSelf</em>
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs>
              <TextField
                style={{ width: 225 }}
                label="Legal first name"
                value={this.state.legalFirstName}
                variant="outlined"
                onChange={this.handleLegalFirstName}
              />
            </Grid>

            <Grid item xs>
              <TextField
                style={{ width: 225 }}
                label="Middle Name (Optional)"
                variant="outlined"
                value={this.state.middleName}
                onChange={this.handleMiddleName}
              />
            </Grid>

            <Grid item xs>
              <TextField
                style={{ width: 225 }}
                label="Legal Last name"
                value={this.state.legalLastName}
                variant="outlined"
                onChange={this.handleLegalLastName}
              />
            </Grid>

            <Grid item xs>
              <FormControl>
                <InputLabel>Suffix (Optional)</InputLabel>
                <Select
                  value={this.state.suffix}
                  onChange={this.handleSuffix}
                  style={{ width: 225 }}
                >
                  <MenuItem value="Jr">Jr</MenuItem>
                  <MenuItem value="Sr">Sr</MenuItem>
                  <MenuItem value="III">III</MenuItem>
                  <MenuItem value="IV">IV</MenuItem>
                  <MenuItem value="V">V</MenuItem>
                  <MenuItem value="None">None</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {!showLoadingSpinner && (
              <Grid item xs>
                <FormControl>
                  <InputLabel>Home Address (Required)</InputLabel>
                  <Select
                    value={this.state.residentialAddressId}
                    style={{ width: 225 }}
                    onChange={this.handleResidentialAddressId}
                  >
                    // @ts-ignore
                    {this.state.addresses.map((address) => (
                      <MenuItem value={address.addressId}>
                        <em>
                          {address.state}, {address.city} {address.postalCode}
                        </em>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            <Grid item xs>
              <FormControl component="fieldset">
                <FormGroup style={{ width: 225 }}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={this.state.setDefaultAddress} />
                    }
                    label="Set Address as Default"
                    onChange={this.handleSetDefaultAddress}
                  />
                </FormGroup>
              </FormControl>

              {this.props.forCheckout && (
                <Grid item xs>
                  <FormControl component="fieldset">
                    <FormGroup style={{ width: 225 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.setDefaultPaymentMethod}
                          />
                        }
                        label="Set Default Credit Card"
                        onChange={this.handleSetDefaultPayment}
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
              )}
            </Grid>

            <Grid item xs>
              <TextField
                label="Date of birth"
                type="date"
                value={this.state.dateOfBirth}
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ width: 225 }}
                onChange={this.handleDateOfBirth}
              />
            </Grid>

            <Grid item xs>
              <FormControl component="fieldset">
                <FormLabel component="legend">Gender</FormLabel>
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  value={this.state.gender}
                  onChange={this.handleGender}
                  style={{ width: 225 }}
                >
                  <FormControlLabel
                    value="Female"
                    control={<Radio />}
                    label="Female"
                  />
                  <FormControlLabel
                    value="Male"
                    control={<Radio />}
                    label="Male"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs>
              <TextField
                style={{ width: 225 }}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                label="Last 4 of SSN (Optional)"
                value={this.state.ssn}
                variant="outlined"
                onChange={this.handleSsn}
                inputProps={{
                  maxLength: 4,
                }}
              />
            </Grid>

            <Grid item xs>
              <FormControl component="fieldset">
                <FormLabel component="legend">Notifications</FormLabel>
                <FormGroup style={{ width: 225 }}>
                  <FormControlLabel
                    control={<Checkbox checked />}
                    label="Email Notifications"
                  />
                  <FormControlLabel
                    disabled
                    control={<Checkbox />}
                    label="SMS Notifications"
                  />
                </FormGroup>
              </FormControl>
            </Grid>

            <Grid item xs>
              <FormControl>
                <InputLabel>Identity Validation Status (Required)</InputLabel>
                <Select
                  value={this.state.identityValidationStatus}
                  onChange={this.handleIdentityValidationStatus}
                  style={{ width: 225 }}
                >
                  <MenuItem value="VALIDATION_SUCCESS">Success</MenuItem>
                  <MenuItem value="VALIDATION_FAILED">Failed</MenuItem>
                  <MenuItem value="VALIDATION_NOT_AVAILABLE">
                    Not Available
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs>
              <FormControl component="fieldset">
                <FormGroup style={{ width: 225 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.identityValidationStatusKatara}
                      />
                    }
                    label="Override Identity Validation Status In Katara"
                    onChange={this.handleIdentityValidationStatusKatara}
                  />
                </FormGroup>
              </FormControl>
            </Grid>

            {this.props.healthProfile && (
              <HealthProfileFieldsSection
                gender={this.state.gender}
                medications={this.state.medications}
                ref={(ref) => (this.healthProfileFieldsSection = ref)}
              />
            )}

            {this.props.forCheckout && (
              <HealthProfileFieldsSection
                gender={this.state.gender}
                medications={this.state.medications}
                forCheckout={this.props.forCheckout}
                ref={(ref) => (this.healthProfileFieldsSection = ref)}
              />
            )}

            {this.props.forOrder && (
              <HealthProfileFieldsSection
                gender={this.state.gender}
                medications={this.state.medications}
                forOrder={this.props.forOrder}
                ref={(ref) => (this.healthProfileFieldsSection = ref)}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  }

  public componentDidMount() {
    this.getAddresses();

    if (this.props.healthProfile) {
      this.getMedications();
    }

    if (this.props.forCheckout || this.props.forOrder) {
      this.getDrugs();
    }
  }

  public getAddresses() {
    getCatalogAddresses()
      .then((addresses) => {
        // Keep the pre-refactor alert so an empty list doesn't spin silently.
        if (addresses.length === 0) {
          alert("Exception occurred when getting addresses.");
        }
        this.setState({ addresses });
      })
      .catch((error) => {
        console.error(error);
        alert("Exception occurred when getting addresses.");
      });
  }

  public getMedications() {
    const apiName = "ApaqPortalAPI";
    const path = "/medication/get-medications";

    API.get(apiName, path, {})
      .then((value: any) => {
        const result = [];
        for (const entry of value.medications) {
          result.push(entry);
        }

        this.setState({ medications: result });
      })
      .catch((error) => {
        console.error(error);
        alert("Exception occurred when getting medications.");
      });
  }

  public getDrugs() {
    const apiName = "ApaqPortalAPI";
    const path = "/drug/get-drugs";

    API.get(apiName, path, {})
      .then((value: any) => {
        const result = [];
        for (const entry of value.medications) {
          result.push(entry);
        }

        this.setState({ medications: result });
      })
      .catch((error) => {
        console.error(error);
        alert("Exception occurred when getting drugs.");
      });
  }

  public handleLegalFirstName(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ legalFirstName: event.target.value });
  }

  public handleMiddleName(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ middleName: event.target.value });
  }

  public handleLegalLastName(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ legalLastName: event.target.value });
  }

  public handleSuffix(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ suffix: event.target.value });
  }

  public handleIdentityValidationStatusKatara(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    this.setState({ identityValidationStatusKatara: event.target.checked });
  }

  public handleIdentityValidationStatus(
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) {
    this.setState({ identityValidationStatus: event.target.value });
  }

  public handleResidentialAddressId(
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) {
    this.setState({ residentialAddressId: event.target.value });
  }

  public handleDateOfBirth(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ dateOfBirth: event.target.value });
  }

  public handleGender(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ gender: event.target.value });
  }

  public handleSsn(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ ssn: event.target.value });
  }

  public handleSetDefaultAddress(event: React.ChangeEvent<HTMLInputElement>) {
    if (!this.state.setDefaultPaymentMethod) {
      this.setState({ setDefaultAddress: event.target.checked });
    }
  }

  public handleSetDefaultPayment(event: React.ChangeEvent<HTMLInputElement>) {
    if (this.state.setDefaultAddress) {
      this.setState({ setDefaultPaymentMethod: event.target.checked });
    } else {
      this.setState({ setDefaultPaymentMethod: event.target.checked });
      this.setState({ setDefaultAddress: event.target.checked });
    }
  }

  public getBasicFieldsSection() {
    return this.basicFieldsSection;
  }

  public getHealthProfileFieldsSection() {
    return this.healthProfileFieldsSection;
  }

  public getState() {
    return this.state;
  }
}

export default DemographicProfileFieldsSection;
